<lm-block-grid *ngIf="blockGridOptions && blockGridOptions.data"
  [showEmptyMessage]="showEmptyMessage"
  [selectionMode]="selectionMode"
  [emptyMessageOptions]="emptyMessage"
  [automationId]="listSpec?.busListSpec?.automationId"
>
  <ng-container content>
    <lm-block-item *ngFor="let data of blockGridOptions.data let i = index"
      [blockGridOptions]="blockGridOptions"
      [data]="data"
      [populateTooltip]="true"
      [width]="'100'"
      [content]="'image-item'"
      [automationId]="listSpec?.busListSpec?.automationId"
      [index]="i"
      (contextMenu)="onContextMenu($event)"
      (itemActivated)="onItemActivated($event)"
      (itemSelected)="onSelected($event)"
      (itemUnSelected)="onUnSelected($event)"
      (itemDoubleClicked)="onDoubleClick($event)"
      #LMBlockItem
    ></lm-block-item>
  </ng-container>
  <ng-container pager>
    <div soho-standalone-pager *ngIf="listSpec && !showAsMingleWidget"
         id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
         class="scrollable-flex-footer"
         [attributes]="pagerIdAttributes"
         [smallPageSizeSelector]="true"
         [pageSizeMenuSettings]="{ attachToBody: true }"

         [enableFirstButton]="hasFirstPage"
         [enablePreviousButton]="hasPreviousPage"
         [enableNextButton]="hasNextPage"
         [enableLastButton]="hasLastPage"

         [firstPageTooltip]="firstPageButtonTooltip"
         [previousPageTooltip]="previousPageButtonTooltip"
         [nextPageTooltip]="nextPageButtonTooltip"
         [lastPageTooltip]="lastPageButtonTooltip"

         [showPageSizeSelector]="showPageSizeSelector"
         [pageSize]="pageSize"
         [pageSizes]="pageSizes"

         (firstPage)="onFirstPage()"
         (previousPage)="onPreviousPage()"
         (nextPage)="onNextPage()"
         (lastPage)="onLastPage()"
         (pageSizeChange)="onPageSizeChange($event)"
    ></div>
  </ng-container>
</lm-block-grid>
